import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  IconButton,
  Tab,
  Tabs,
} from "@mui/material";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import SearchBar from "../../components/SearchBar";
import VehicleListings from "../../features/manageVehicles/vehicleListings";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = ({ children, value, index }: TabPanelProps) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && children}
  </div>
);

const a11yProps = (index: number) => ({
  id: `tab-${index}`,
  "aria-controls": `tabpanel-${index}`,
});

const tabTypes = ["Car", "Bike", "Bicycle", "Caravan", "Trucks", "Heavy Equipment"];

const ManageUserDetail = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const profileInfo = [
    { label: "Full Name", value: "Madelyn Dias" },
    { label: "Email", value: "madelyndias@gmail.com" },
    { label: "Phone", value: "9876543210" },
    { label: "Gender", value: "Female" },
    { label: "Country", value: "India" },
    { label: "State", value: "Maharashtra" },
    { label: "City", value: "Pune" },
    { label: "Nationality", value: "Indian" },
    { label: "Date Registered", value: "01 March 2025" },
  ];

  const stats = [
    {
      icon: <DirectionsCarFilledIcon />,
      count: 50,
      label: "Posted Cars",
    },
    {
      icon: <BookmarkIcon />,
      count: 15,
      label: "Saved/Shortlisted Cars",
    },
  ];

  return (
    <>
      {/* Page Title */}
      <div className="main_title">
        <h1>Customer Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          <button onClick={() => navigate("/manage-users")}>
            Customer Management
          </button>{" "}
          – Customer Detail
        </p>
      </div>

      {/* Tabs */}
      <div className="table_header">
        <Box className="custom_tabs1">
          <Tabs
            value={activeTab}
            onChange={(_, val) => setActiveTab(val)}
            className="custom_tabs_links"
          >
            <Tab label="Profile Information" {...a11yProps(0)} />
            <Tab label="Posted Cars" {...a11yProps(1)} />
            <Tab label="Saved/Shortlisted Cars" {...a11yProps(2)} />
          </Tabs>
        </Box>
      </div>

      {/* Profile Information */}
      <CustomTabPanel value={activeTab} index={0}>
        <div className="cards view_page">
          <div className="table_header mb_20">
            <h2>Profile Information</h2>
            <span className="status_btn dark c_success">Active</span>
          </div>

          <div className="gap_p">
            <div className="vew_img w_100">
              <h6>Image</h6>
              <figure>
                <img alt="user" src="/static/images/user_placeholder.png" />
              </figure>
            </div>
            {profileInfo.map((item, index) => (
              <div className="w_33" key={index}>
                <h6>{item.label}</h6>
                <p>{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="cards view_page">
          <div className="table_header mb_20">
            <h2>Documents</h2>
          </div>


          <div className="gap_p">
            <div className="w_50">
              <h6>Driving License</h6>
              <div className="doc_preview">
                <AttachFileIcon /> <p>driving-license.jpg</p> <IconButton className='btn_rounded primary'><FileDownloadOutlinedIcon /></IconButton>
              </div>
            </div>
          </div>
        </div>

        <div className="cards view_page">
          <div className="table_header mb_20">
            <h2>Activity & Engagement</h2>
          </div>

          <div className="stats_boxes v2 gap_m">
            {stats.map((stat, index) => (
              <div className="cards w_33" key={index}>
                <figure>{stat.icon}</figure>
                <h2>{stat.count}</h2>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </CustomTabPanel>

      {/* Posted Cars */}
      <CustomTabPanel value={activeTab} index={1}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="custom_tabs" sx={{ width: "100%" }}>
                <Tabs
                  value={valueTabs}
                  onChange={handleChangeTabs}
                  className="custom_tabs_links mb_0"
                >
                  {tabTypes.map((label, index) => (
                    <Tab key={label} label={label} {...a11yProps(index)} />
                  ))}
                </Tabs>
              </Box>
            </div>
            <div className="right_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search Vehicles..."
              />
            </div>
          </div>
          {tabTypes.map((type, tabIndex) => (
            <CustomTabPanel key={type} value={valueTabs} index={tabIndex}>
              <VehicleListings type={type} searchTerm={searchTerm} featured={false} />
            </CustomTabPanel>
          ))}
        </div>
      </CustomTabPanel>

      {/* Saved Cars */}
      <CustomTabPanel value={activeTab} index={2}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="custom_tabs" sx={{ width: "100%" }}>
                <Tabs
                  value={valueTabs}
                  onChange={handleChangeTabs}
                  className="custom_tabs_links mb_0"
                >
                  {tabTypes.map((label, index) => (
                    <Tab key={label} label={label} {...a11yProps(index)} />
                  ))}
                </Tabs>
              </Box>
            </div>
            <div className="right_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search Vehicles..."
              />
            </div>
          </div>
          {tabTypes.map((type, tabIndex) => (
            <CustomTabPanel key={type} value={valueTabs} index={tabIndex}>
              <VehicleListings type={type} searchTerm={searchTerm} featured={false} />
            </CustomTabPanel>
          ))}
        </div>
      </CustomTabPanel>
    </>
  );
};

export default ManageUserDetail;